import React from 'react';
import { AlertTriangle } from 'lucide-react';
import '../../styles/components/success-modal.css';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  status?: 'success' | 'failed';
  showAlertIcon?: boolean;
  actionText?: string;
  onAction?: () => void;
  secondaryActionText?: string;
  onSecondaryAction?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  status = 'success',
  showAlertIcon = false,
  actionText,
  onAction,
  secondaryActionText,
  onSecondaryAction
}) => {
  if (!isOpen) return null;

  return (
    <div className="sm-overlay zoomOutLevel">
      <div className="sm-card">
        <div className="sm-body">
          {/* Alert icon — opt-in via prop */}
          {showAlertIcon && (
            <div className="sm-alert-icon">
              <AlertTriangle size={32} />
            </div>
          )}

          {/* Title */}
          <h3 className="sm-title">{title}</h3>

          {/* Subtitle */}
          {subtitle && (
            <p className="sm-subtitle">{subtitle}</p>
          )}

          {/* Action Buttons */}
          <div className="sm-actions">
            {(actionText && onAction) || (!actionText && !onAction) ? (
              <button
                onClick={onAction || onClose}
                className={`success-modal-ok-button sm-btn sm-btn--primary ${status === 'failed' ? 'sm-btn--failed' : ''}`}
              >
                {actionText || 'OK'}
              </button>
            ) : null}
            {secondaryActionText && onSecondaryAction && (
              <button
                onClick={onSecondaryAction}
                className="sm-btn sm-btn--secondary"
              >
                {secondaryActionText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;